import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import TryFreeCta from '@/components/TryFreeCta'

import styles from './Popup.module.scss'

const Popup = ({
  postSlug = '',
  exitIntent = false,
}) => {
  const [showPopup, setShowPopup] = useState(false)
  const [isDismissed, setIsDismissed] = useState(false)

  const handleScroll = () => {
    if (window.scrollY > 1000 && !isDismissed) {
      setShowPopup(true)
    }
  }

  const handleMouseOut = (event) => {
    if (event.clientY < 10 && !isDismissed && exitIntent) {
      setShowPopup(true)
    }
  }

  const handleClose = () => {
    setShowPopup(false)
    setIsDismissed(true)
  }

  useEffect(() => {
    if (exitIntent) {
      document.addEventListener('mouseout', handleMouseOut)
    } else {
      window.addEventListener('scroll', handleScroll)
    }

    return () => {
      if (exitIntent) {
        document.removeEventListener('mouseout', handleMouseOut)
      } else {
        window.removeEventListener('scroll', handleScroll)
      }
    }
  }, [isDismissed, exitIntent])

  useEffect(() => {
    // Reset state variables when postSlug changes
    setShowPopup(false)
    setIsDismissed(false)
  }, [postSlug])

  return (
    <div>
      {showPopup && (
        <div className={styles.popup}>
          <button className={styles.closePopupBtn} onClick={handleClose}>x</button>
          <div className={styles.popupContent}>
            <h3>Track Receipts<br /> Track Expenses</h3>
            <p>A smarter way to manage your receipts, documents, report expenses, and much more!</p>
            <TryFreeCta />
          </div>
        </div>
      )}
    </div>
  )
}

Popup.propTypes = {
  postSlug: PropTypes.string,
  exitIntent: PropTypes.bool,
}

export default Popup
